import React from 'react'

import styled from 'styled-components'
import { Checkbox, Form, Input, Segment } from 'semantic-ui-react'

import EmptyState from 'shared/components/EmptyState'
import { NewTabLink } from 'components/NewTabLink'

const CheckboxOptions = styled.div`
  margin: 16px 0;
  color: var(--ss-link-color);

  a {
    cursor: pointer;
  }
`

export default function EditUserSurveyAccessFormContent({
  handleSearchChange,
  selectAllOptions,
  clearAllOptions,
  onCheckboxChange,
  surveys,
}) {
  return (
    <div className="ui form mb3">
      <Form.Field>
        <label>Survey access</label>
      </Form.Field>
      <Form.Group grouped>
        <Segment>
          <Input
            fluid
            icon="far fa-magnifying-glass"
            iconPosition="left"
            className="search"
            placeholder="Search surveys"
            onChange={handleSearchChange}
          />
          {surveys.length > 0 ? (
            <React.Fragment>
              <CheckboxOptions>
                <a onClick={selectAllOptions}>Select all</a>
                {` · `}
                <a onClick={clearAllOptions}>Deselect all</a>
              </CheckboxOptions>
              {surveys.map((survey, index) => {
                return (
                  <Form.Field key={index}>
                    <Checkbox
                      label={{
                        children: <div>{survey.name}</div>,
                      }}
                      checked={survey.has_permission}
                      onChange={() => onCheckboxChange(survey)}
                    />
                  </Form.Field>
                )
              })}
            </React.Fragment>
          ) : (
            <Form.Field>
              <EmptyState
                icon={<i className="far fa-poll-h" />}
                callToAction={
                  <NewTabLink to="/settings/surveys/?create=true">Create a new survey.</NewTabLink>
                }
              >
                Your account doesn't have any surveys yet.
              </EmptyState>
            </Form.Field>
          )}
        </Segment>
      </Form.Group>
    </div>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/EditUserSurveyAccessInput/index.js